import React, { useEffect, useState, Fragment, useRef } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const deductionTypeNamesOfTable = this.props.deductionTypeNamesOfTable;
        const searchData = this.props.searchData;
        const colName = this.props.initialData;
        const summeryValues = this.props.summeryValues;
        const summeryData = this.props.summeryData;
        return (
            <div className="p-2">
                <h3><center><u>BL Supplier Wise Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Supplier Name: </b> {searchData.collectionPoint === undefined ? 'All' : searchData.collectionPoint}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <TableContainer component={Paper} style={{ border: "1px solid black" }}>
                    <Table aria-label="simple table" style={{ border: "1px solid black" }}>
                        <TableHead style={{ border: "1px solid black" }}>
                            <TableRow style={{ border: "2px solid black" }}>
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Supplier Name
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Supplier Code
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Bag Count
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Actual Amount
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Gross Amount
                                </TableCell>
                                {deductionTypeNamesOfTable.map((item) => (
                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align='center'>{item}</TableCell>
                                ))}
                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                    Net Amount
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ border: "1px solid black" }}>
                            {data.map((row) => (
                                <TableRow key={row.employeeCode} style={{
                                    border: "2px solid black",
                                    backgroundColor: row.isActive === false ? "lightgreen" : "inherit"
                                }}
                                >
                                    <TableCell component="th" scope="row" style={{ border: "2px solid black" }}>
                                        {row.collectionPointName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                        {row.bplDivisionID}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                        {row.count}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                        {row.factualAmount}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                        {row.fGrossAmount}
                                    </TableCell>

                                    {deductionTypeNamesOfTable.map((column) => {
                                        const value = row[column];
                                        return (
                                            <TableCell align='right' style={{ border: "2px solid black" }}>{value == undefined ? '-' : value}</TableCell>
                                        );
                                    })}
                                    <TableCell align="right" style={{ border: "2px solid black" }}>{Math.floor(row.fNetAmount)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableBody style={{ border: "1px solid black" }}>
                            <TableRow style={{ border: "2px solid black" }}>
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="left">
                                    Total
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="left">
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                    {summeryValues.bagTot}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                    {parseFloat(summeryValues.actualTot).toFixed(2)}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                    {parseFloat(summeryValues.grossTot).toFixed(2)}
                                </TableCell>
                                {deductionTypeNamesOfTable.map((item) => {
                                    var result = summeryData.find(y => y.name === item);
                                    return (
                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align='right'>{result == undefined ? parseFloat(0).toFixed(2) : parseFloat(result.value).toFixed(2)}</TableCell>
                                    );
                                })}
                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                    {Math.floor(summeryValues.netTot)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}


